import { useFetchHeadOfficeWrappersQuery } from "../../../services/headofficeadmin";
import FormSelect from "../FormSelect";

const HeadOfficeWrappersSelect = ({
    defaultValue,
    label,
    onBlur,
    onChange,
    ...rest
}) => {

    const { data, isLoading } = useFetchHeadOfficeWrappersQuery();

    return <FormSelect
        defaultValue={defaultValue}
        isLoadingOptions={isLoading}
        label={label}
        onBlur={onBlur}
        onChange={onChange}
        options={data}
        {...rest}
    />;
};

export default HeadOfficeWrappersSelect;